import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const AddObjectRole = ({ position, options, onOptionClick, onClose }) => {
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };
    window.addEventListener('mousedown', handleClickOutside);
    return () => window.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  if (!options || options.length === 0) return null;

  const flowContainer = document.querySelector('.publishcontainer');
  if (!flowContainer) return null;

  const containerRect = flowContainer.getBoundingClientRect();

  // ⚙️ Relative position inside the container
  let x = position.x - containerRect.left + 10; // thoda right
  let y = position.y - containerRect.top + 10; // thoda below

  const menuWidth = 200;
  const menuHeight = options.length * 40;

  // 🔹 Smart open direction (upar ya niche)
  const spaceBelow = containerRect.height - (y + menuHeight);
  if (spaceBelow < 0) {
    // Agar bottom me space kam hai, upar open karo
    y = y - menuHeight - 10;
  }

  // 🔹 Clamp to container bounds
  const maxX = containerRect.width - menuWidth - 10;
  const maxY = containerRect.height - menuHeight - 10;

  x = Math.min(Math.max(x, 10), maxX);
  y = Math.min(Math.max(y, 10), maxY);

  return (
    <div
      className="swimlane_add_dropdown"
      ref={menuRef}
      style={{
        ...styles.container,
        top: y,
        left: x,
      }}
      onContextMenu={(e) => e.preventDefault()}
    >
      {options.map((option, index) => (
        <div
          className="menuitems"
          key={index}
          style={styles.option}
          onClick={() => {
            onOptionClick(option.value);
            onClose();
          }}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    position: 'absolute',
    background: '#e7e7e7',
    borderRadius: '4px',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    minWidth: '200px',
  },
  option: {
    padding: '10px 12px',
    cursor: 'pointer',
    color: '#011f60',
    fontWeight: '500',
    borderBottom: '1px solid rgb(255, 255, 255)',
  },
};

AddObjectRole.propTypes = {
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
  onOptionClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddObjectRole;
